import { SelectCombo } from 'components/Types/GeneralTypes';
import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { StylesConfig } from 'react-select';
import Icon from '../Icons';

type PropsAsyncSelect = {
  value: SelectCombo | undefined | null,
  icon: string,
  placeholder: string,
  onChange: (value: SelectCombo | undefined) => void,
  onFind: (inputValue: string) => Promise<SelectCombo[]>,
  name?: string
  noOptionsMessage?:string,
  loadingMessage?:string 
}



export default function FindAsyncSelect(props: PropsAsyncSelect) {

  const [value, setvalue] = useState<SelectCombo | null | undefined>(props.value)
  const [isLoading, setIsLoading] = useState<boolean>(false); // Estado para gestionar si está cargando
  const [typingTimeout, setTypingTimeout] = useState<number | null>(null); // Estado para gestionar el delay


  useEffect(() => {
    if(props.value){
      setvalue(props.value)
    }
    else {
      setvalue(null)
    }
    
  }, [props.value])
  

  const normalizeString = (str: string) => {

    // Definir la expresión regular usando new RegExp
    const accentRegex = new RegExp('[\u0300-\u036f]', 'g');
    // Convertir el texto a mayúsculas y eliminar las tildes
    const formattedValue = str
      .toUpperCase() // Convertimos a mayúsculas
      .normalize('NFD') // Descomponemos los caracteres con tildes
      .replace(accentRegex, ''); // Eliminamos las tildes utilizando el objeto RegExp
    return formattedValue
  };

  // Cargar opciones solo cuando se cumple con el requisito de espacio o apellido/nombre
  const loadOptions = (inputValue: string, callback: (options: SelectCombo[]) => void) => {
    // Limpiar el timeout anterior si el usuario sigue escribiendo
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Nueva lógica para hacer fetch al dejar de escribir o presionar barra espaciadora
    const newTimeout = setTimeout(async () => {
      const trimmedValue = normalizeString(inputValue);
      // Verifica si hay al menos un espacio o si se ha escrito algo con al menos 3 caracteres
      if (trimmedValue.length > 2) {

        setIsLoading(true); // Bloqueamos el input mientras cargan los datos
        const options = await props.onFind(trimmedValue);
        setIsLoading(false); // Desbloqueamos el input después de que se completa la carga
        callback(options);

      } else {
        callback([]);
      }

    }, 500);

    setTypingTimeout(newTimeout as unknown as number); // Guardamos el timeout actual


  }

  // Manejo de cambio de selección
  const handleChange = (seleccionado: SelectCombo) => {
    setvalue(seleccionado)
    props.onChange(seleccionado)
  }

  // Manejamos el evento de escribir para detectar barra espaciadora
  const handleInputChange = (newValue: string) => {

    const formattedValue = normalizeString(newValue);
    // Aquí verificamos si se ha presionado la barra espaciadora
    if (formattedValue.endsWith(' ')) {
      // Si se ha presionado, limpiamos el timeout y hacemos el fetch inmediatamente
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      loadOptions(formattedValue, () => { });
    }
    return formattedValue;
  };

  const customStyles: StylesConfig<SelectCombo, false> = {
    container: (provided, state) => ({
      ...provided,
      position: "relative",
      width: "100%",
      marginBottom: "0",
    }),
    control: (provided, state) => {
      const backgroundColor = state.isDisabled ? "#E3E3E3" : "#fff";
      return {
        ...provided,
        borderRadius: "0px",
        border: "1px solid #E3E3E3",
        backgroundColor,
        color: "#2c2c2c",
        minHeight: "27px",
        height: "27px",
        fontSize: "0.8571em",
        boxShadow: "none",
        width: "auto",
        fontFamily: "Montserrat",
      }
    },
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (provided, state) => ({
      ...provided,
      fontSize: "0.95em",
      minWidth: "300px",
      zIndex: "100",
    }),

  }




  return (
    <div className="input-group">

      <AsyncSelect
        value={value}
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        placeholder="Buscar nombre o apellido..."
        onChange={handleChange}
        isClearable
        styles={customStyles}
        isLoading={isLoading}
        // isDisabled={isLoading}
        onInputChange={handleInputChange}
        noOptionsMessage={({ inputValue }) =>
          inputValue ?  "No hay opciones" : props.noOptionsMessage ? props.noOptionsMessage : "No hay opciones" 
        }
        loadingMessage={() => props.loadingMessage?props.loadingMessage:"Buscando..."}
      />
      <div className="icon-inside-select" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
        {props.icon.startsWith("fa-") ? (<i className={"fas " + props.icon} aria-hidden="true" ></i>) : (<Icon kind={props.icon} fill='#FF0000' width={10} height={10} />)}
      </div>
    </div>
  );
};

